import { render, staticRenderFns } from "./ProfileDialogComponent.vue?vue&type=template&id=fec5a3f6&"
import script from "./ProfileDialogComponent.vue?vue&type=script&lang=js&"
export * from "./ProfileDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDialogComponent.vue?vue&type=style&index=0&id=fec5a3f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports